import { RootState } from '@reducers';

export const selectFeatureProvince = (state: RootState) => state.featureReducer.provinceReducer;
